import copy from "copy-to-clipboard";
import { action } from "@k8slens/lds-icons";
import styles from "./CopyToClipboard.module.css";

const { CopyPasteIcon } = action;

export const CopyToClipboard = ({ text, onCopy } : { text: string, onCopy?: (text: string) => void }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    copy(text);

    onCopy && onCopy(text);
  };

  return <button type="button" className={styles.copy} aria-label="Copy co clipboard" title="Copy to clipboard" onClick={handleClick}><CopyPasteIcon /></button>;
};
